import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import styles from './style.module.css';
import clsx from "clsx";
import close from "../../../assets/close.svg";
import { PriceDetailsOpen, Set_Open_ChatHistory } from "../../../Redux/actions/actionNames";
import Receipt from "../../../assets/receipt.svg";
import notes from "../../../assets/notes23.svg";
import { isOrderInDone } from "../../../helper/module";
import { isEmpty } from "lodash";
import { checkTimestamp, get_lang, get_timeFormat } from "../../../helper/UserData/userdate";
import noResultImg from '../../../assets/ic-search-not-found.svg';
import { GetOrderChats } from "../../../helper/api";
import Typography from "../../../design-system/lib/Typography";
import jalali from "jalali-moment";
import momentJalaali from "moment-jalaali";
import { avatar, chat_gray, DRIVER_COLOR, driverChat, PERSON } from "../../../assets";

class ChatHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chats : [],
      loading : false
    }
  }

    getTodayTomorowYesterday = (datexx) => {
          let date = new Date(datexx);
 
        return `${jalali(datexx).locale(get_lang()).format(checkTimestamp(datexx))}`;
   
      }  

  closeDialoge = () => {
    this.props.dispatch(Set_Open_ChatHistory(false))
  }

     componentDidMount() {
      if(this.props.OrderId && !isEmpty(this.props.OrderId)  && this.props.open){
        this.setState({
                loading : true
              })
      }
      (this.props.OrderId && !isEmpty(this.props.OrderId) && this.props.open) &&  GetOrderChats(this.props.dispatch ,this.props.OrderId , (res)=>{
        this.setState({
          loading : false
        })
         if(res && res.res){
             this.setState({
               chats : res.res
             })
         }
         this.setState({
          loading : false
        })
      } )

     
     }

     componentWillReceiveProps(nextProps) {
      if(nextProps.OrderId && !isEmpty(nextProps.OrderId) && nextProps.open){
        this.setState({
                loading : true
              })
      }
        (nextProps.OrderId && !isEmpty(nextProps.OrderId)  && nextProps.open) &&  GetOrderChats(this.props.dispatch ,nextProps.OrderId , (res)=>{
          if(res && res.res){
            this.setState({
              chats : res.res
            })
        }
         this.setState({
          loading : false
        })
       } )

     
     }

  


  render() {
    const groupedChats = groupChats(this.state.chats);
    console.log("groupedChats ",groupedChats)
    return (

      <div className={clsx(styles.EventTimeLineContainer, this.props.open && styles.EventTimeLineContainerOpen)}>
        <div className={styles.EventTimeLine_Header}>
          <img onClick={this.closeDialoge} className={styles.close} src={close} />
          <span className={styles.eventsTitle}> <Trans i18nKey={"chat"}> </Trans> </span>
   
          </div>

        <div className={styles.card}>
        {this.state.loading && <span class="loader2" style={{marginInlineStart:"-48px",marginTop:"calc(50vh - 90px)"}}></span>}
          {((!this.state.chats || this.state.chats?.length == 0) && !this.state.loading) && <div className={styles.searchNoResultContainer} style={{ marginTop: "calc(50vh - 70px)" }}>
            <img src={chat_gray} className={styles.searchNoResultImg} style={{ marginBottom: "16px" }} />
            <Typography weight="Body_Middle_Bold" style={{ color: "rgba(36, 36, 36, 1)", marginBottom: "4px" }} text={this.props.t("No message")} />
            <Typography weight="Body_Tiny_Regular" style={{ color: "rgba(128, 128, 128, 1)", maxWidth: "243px", textAlign: "center" }} text={this.props.t("Message between customer and driver will be show here")} />
        </div>}


        {( this.state.chats && this.state.chats?.length > 0 && groupedChats && !this.state.loading) && <div className={styles.chatContainer}>
            {groupedChats.map((group, index) => (
                <div key={index}>
                    <div className={styles.dateHeader}>
                        
                        <Typography weight="Body_Tiny_Regular" text={this.getTodayTomorowYesterday(group.createdAt)} style={{color:"rgba(128, 128, 128, 1)"}} />
                    </div>
                 
                    {group.messages.map((message) => (
                       <div className={`${styles[`chatxContainer${message.source}`]}`}>
                        <img src={message.source == "driver" ? (this.props.driver && this.props.driver.avatarPhoto.length > 0) ? this.props.driver.avatarPhoto : driverChat : `${this.props.customer &&
                          this.props.customer.avatarPhoto &&
                          this.props.customer.avatarPhoto.length !== 0
                          ? this.props.customer.avatarPhoto
                          : avatar
                          }`} onError={({ currentTarget }) => {
                                              currentTarget.onerror = null; // prevents looping
                                              currentTarget.src = message.source == "driver" ? driverChat :avatar;
                                          }} style={{ width: "24px", marginInlineEnd: message.source == "driver" && "6px", marginInlineStart: message.source != "driver" && "6px", alignSelf: "end" , borderRadius:"50%" }} />
                           <div className={`${styles[`chatBubbleContainer${message.source}`]}`}>
                            {    message.messages.map((messagex, msgIndexx) => (
                          <div className={`${styles.chatMessage} ${styles[messagex.source]} ${msgIndexx === message.messages.length - 1 && styles["border"+messagex.source]}`} key={message.id}>
                              <p>{messagex.text}</p>
                              <span>{jalali(messagex.createdAt).locale(get_lang()).format(get_timeFormat())}</span>
                              
                          </div>
                      )) }
                          </div>
                    </div>
                    ))}
                </div>
            ))}
        </div>}
  
        </div>


      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.ViewTravel.chatOpen,
  OrderId: state.ViewTravel.pureData ? state.ViewTravel.pureData?.id : null,
  customer: state.ViewTravel.pureData?.customer,
  driver: state.ViewTravel.pureData?.driver

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ChatHistory));


const groupChats = (chats) => {
  if(!chats){
    return 
  }
  const grouped = [];
    
  chats.forEach(chat => {
      const date = new Date(chat.createdAt).toLocaleDateString(); 
      const existingGroup = grouped.find(group => group.date === date);

      if (existingGroup) {
          existingGroup.messages.push(chat);
      } else {
          grouped.push({ date:date , createdAt : chat.createdAt, messages: [chat] });
      }
  });

  grouped.forEach(group => {
      const finalMessages = [];
      for (let i = 0; i < group.messages.length; i++) {
          const message = group.messages[i];
          if (finalMessages.length === 0 || finalMessages[finalMessages.length - 1].source !== message.source) {
              finalMessages.push({ source: message.source, messages: [message] });
          } else {
              finalMessages[finalMessages.length - 1].messages.push(message);
          }
      }
      group.messages = finalMessages;
  });

  return grouped;
};


